module.exports = __webpack_public_path__ + "static/media/foto3.d31f394e.png";